import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const CloseIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_460_10641)">
        <g clipPath="url(#clip1_460_10641)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99984 2.41675C5.81168 2.41675 2.4165 5.81192 2.4165 10.0001C2.4165 14.1882 5.81168 17.5834 9.99984 17.5834C14.188 17.5834 17.5832 14.1882 17.5832 10.0001C17.5832 5.81192 14.188 2.41675 9.99984 2.41675ZM0.916504 10.0001C0.916504 4.98349 4.98325 0.916748 9.99984 0.916748C15.0164 0.916748 19.0832 4.98349 19.0832 10.0001C19.0832 15.0167 15.0164 19.0834 9.99984 19.0834C4.98325 19.0834 0.916504 15.0167 0.916504 10.0001ZM13.0302 6.96975C13.3231 7.26264 13.3231 7.73752 13.0302 8.03041L11.0605 10.0001L13.0302 11.9697C13.3231 12.2626 13.3231 12.7375 13.0302 13.0304C12.7373 13.3233 12.2624 13.3233 11.9695 13.0304L9.99983 11.0607L8.03016 13.0304C7.73727 13.3233 7.2624 13.3233 6.9695 13.0304C6.67661 12.7375 6.67661 12.2626 6.9695 11.9697L8.93917 10.0001L6.9695 8.03041C6.67661 7.73752 6.67661 7.26264 6.9695 6.96975C7.2624 6.67686 7.73727 6.67686 8.03016 6.96975L9.99983 8.93942L11.9695 6.96975C12.2624 6.67686 12.7373 6.67686 13.0302 6.96975Z"
            fill={fillColor || 'url(#paint0_linear_460_10641)'}
            fillOpacity="0.8"
          />
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_460_10641" x1="9.99984" y1="0.916748" x2="9.99984" y2="19.0834" gradientUnits="userSpaceOnUse">
          <stop stopColor="#C4C9CF" />
          <stop offset="0.96" stopColor="#E9EDF1" />
        </linearGradient>
        <clipPath id="clip0_460_10641">
          <rect width="20" height="20" fill={fillColor || 'white'} />
        </clipPath>
        <clipPath id="clip1_460_10641">
          <rect width="20" height="20" fill={fillColor || 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export { CloseIcon };
